<template lang="pug">
  
  form( v-on:submit.prevent="submit" )
    p( class="text-right" )
      em (* = required field)
    slot
    p( class="text-right" )
      button( type="submit" class="btn btn-primary" v-bind:disabled="disabled" ) {{ submitText || 'Save' }}
  
</template>

<script>
import Vue from 'vue'
export default Vue.extend({

  props: [ 'submitText', 'disabled' ],

  methods: {

    submit(e) {
      
      const inputSelectors = [
        'input[data-moonpull-input="true"][name]',
        'select[data-moonpull-input="true"][name]',
        'textarea[data-moonpull-input="true"][name]'
      ]

      // Extract all Moonpull inputs
      const inputs = e.target.querySelectorAll(inputSelectors.join(','))

      // Construct form data
      const data = {}
      for (let i = 0; i < inputs.length; i++) {
        
        const input = inputs[i]
        const updateNull = input.getAttribute('data-moonpull-update-null') === 'true'

        let value = input.value

        // If the value is empty, ignore this piece of data if we don't want to update null
        if (! updateNull && value === '' && input.type !== 'checkbox') continue

        // Handle files
        if (input.type === 'file') {
          value = input.files
        }
        // Convert number input values to actual numbers
        else if (input.type === 'number') {
          value = Number(value)
        }
        // Convert checkbox input to true/false
        else if (input.type === 'checkbox') {
          value = input.checked
        }
        // Handle select-multiple as an array
        else if (input.type === 'select-multiple') {
          value = Array.from(input.selectedOptions).map(option => option.value)
        }
        // Convert "true" to true
        else if (value === 'true') {
          value = true
        }
        // Convert "false" to false
        else if (value === 'false') {
          value = false
        }
        // Convert "" to null
        else if (value === '') {
          value = null
        }

        // Handle "array" inputs
        if (input.name.endsWith('[]')) {

          // Grab the name of the array e.g. "roles[]" becomes "roles"
          const [ name ] = input.name.split('[]')

          // Initialise the array for this input + future inputs with the same array name
          if (! data[name]) {
            data[name] = []
          }

          // For arrays of checkboxes, change the value to the "value" attribute rather than the "checked" attribute
          // and only push the value if "checked" is true
          if (input.type === 'checkbox') {
            if (! input.checked) continue
            value = input.value
          }

          // Push this value as an entry
          data[name].push(value)
        }
        // Or standard inputs
        else {
          data[input.name] = value
        }
      }

      // Submit event
      this.$emit('submit', data)
    }

  }

})
</script>